// store/currentAssetStore.js
import { create } from 'zustand';

const useCurrentAssetStore = create((set) => ({
  slug: '',
  collection: '',
  link: '', 

  // Действие для установки текущего asset вместе с ссылкой
  setCurrentAsset: (slug, collection, link) => set({ slug, collection, link }),

  // Действие для очистки текущего asset
  clearCurrentAsset: () => set({ slug: '', collection: '', link: '' }),
})); 

export default useCurrentAssetStore;
